module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-800.b457a8d5.woff2";